module.exports = "/static/assets/4838eb6833f72e35dff3df69f5861eec.png";